import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { isType, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  blobDownload,
  getSample,
  postSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  postExcel,
  getGoodsPositionMtnFindDetail,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Select from 'components/Material/Select';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import CheckBox from 'components/Material/Checkbox';
import Input from 'components/Material/Input';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from 'components/Header';
import {
  checkboxChange,
  formatDate,
  getDateDayPlus,
  getFindDropDownList,
  getFindDropDownOneList,
  getWarehouse,
  initWhrehhouse,
  inputChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster, IresultHawbNo } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 拆櫃預定表維護 */
const GoodsPositionMtn = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'goodsPositionMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');

  const [storageAreaOptions, setStorageAreaOptions] = useState<Ioption[]>([]);
  const [locationDescOptions, setLocationDescOptions] = useState<Ioption[]>([]);
  const [goodsTypeOptions, setGoodsTypeOptions] = useState<Ioption[]>([]);
  const [mawbNoOptions, setMawbNoOptions] = useState<string[]>([]);
  const [goodsImageFile, setGoodsImageFile] = useState('');
  const [hwbImageFile, setHwbImageFile] = useState('');

  const masterDefaultValue: Imaster = {
    storageAreaId: '',
    storageAreaDesc: '',
    locationDesc: '',
    goodsType: 'GT001',
    hawbNo: '',
    mawbNo: '',
    hwbImageFile: '',
    goodsImageFile: '',
    hwbImageFileName: '',
    goodsImageFileName: '',
    declPiece: '',
    storagePiece: '',
    length: '',
    width: '',
    height: '',
    weight: '',
    processCustoms: '',
    goodsDesc: '',
    remark: '',

    expressid: '',
    gciDate: '',

    statusCode: '',

    chkCode1: '',
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [hawbNo, setHawbNo] = useState<IresultHawbNo[]>([]);

  const setDetail = (
    goodsPositionMtnDetail: IresultHawbNo,
    statusCodeTemp: string
  ) => {
    setMaster((prev) => ({
      ...prev,
      storageAreaId: goodsPositionMtnDetail.storageAreaId
        ? goodsPositionMtnDetail.storageAreaId
        : master.storageAreaId,

      hwbImageFile: goodsPositionMtnDetail.hwbImageSrc
        ? goodsPositionMtnDetail.hwbImageSrc
        : '',
      goodsImageFile: goodsPositionMtnDetail.goodsImageSrc
        ? goodsPositionMtnDetail.goodsImageSrc
        : '',
      hwbImageFileName: goodsPositionMtnDetail.hwbImageFile
        ? goodsPositionMtnDetail.hwbImageFile
        : '',
      goodsImageFileName: goodsPositionMtnDetail.goodsImageFile
        ? goodsPositionMtnDetail.goodsImageFile
        : '',
      declPiece: goodsPositionMtnDetail.declPiece
        ? goodsPositionMtnDetail.declPiece
        : '',
      storagePiece: goodsPositionMtnDetail.storagePiece
        ? goodsPositionMtnDetail.storagePiece
        : '',
      length: goodsPositionMtnDetail.length
        ? goodsPositionMtnDetail.length
        : '',
      width: goodsPositionMtnDetail.width ? goodsPositionMtnDetail.width : '',
      height: goodsPositionMtnDetail.height
        ? goodsPositionMtnDetail.height
        : '',
      weight: goodsPositionMtnDetail.weight
        ? goodsPositionMtnDetail.weight
        : '',
      processCustoms: goodsPositionMtnDetail.processCustoms
        ? goodsPositionMtnDetail.processCustoms
        : '',
      remark: goodsPositionMtnDetail.remark
        ? goodsPositionMtnDetail.remark
        : '',
      goodsDesc: goodsPositionMtnDetail.goodsDesc
        ? goodsPositionMtnDetail.goodsDesc
        : '',
      expressid: goodsPositionMtnDetail.expressid
        ? goodsPositionMtnDetail.expressid
        : '',
      gciDate: goodsPositionMtnDetail.gciDate
        ? goodsPositionMtnDetail.gciDate
        : '',
      goodsType: goodsPositionMtnDetail.goodsType
        ? goodsPositionMtnDetail.goodsType
        : 'GT001',
      statusCode: statusCodeTemp,
    }));

    getFindDropDownList('findDropDownStorageLocation', {
      warehouse: locationCode,
      storageAreaId: goodsPositionMtnDetail.storageAreaId
        ? goodsPositionMtnDetail.storageAreaId
        : master.storageAreaId,
    })
      .then((item) => {
        setLocationDescOptions(item);
      })
      .then(() => {
        setMaster((prev) => ({
          ...prev,
          locationDesc: goodsPositionMtnDetail.locationDesc
            ? goodsPositionMtnDetail.locationDesc
            : master.locationDesc,
        }));
      });
  };
  const setEmptyDetail = () => {
    setMaster((prev) => ({
      ...prev,
      hwbImageFile: '',
      goodsImageFile: '',
      hwbImageFileName: '',
      goodsImageFileName: '',
      declPiece: '',
      storagePiece: '',
      length: '',
      width: '',
      height: '',
      weight: '',
      processCustoms: '',
      remark: '',
      goodsDesc: '',
      expressid: '',
      gciDate: '',
      statusCode: '',
      goodsType: 'GT001',
    }));
  };
  const setEmptyHawbNo = () => {
    setMaster((prev) => ({
      ...prev,
      hawbNo: '',
      mawbNo: '',
      storageAreaId: '',
      locationDesc: '',
    }));
    setEmptyDetail();
  };
  const iniList = () => {
    if (locationCode) {
      getFindDropDownList('findDropDownStorageArea', {
        warehouse: locationCode,
      }).then((item) => {
        setStorageAreaOptions(item);
      });
      getFindDropDownList('findDropDownStorageLocation', {
        warehouse: locationCode,
        storageAreaId: master.storageAreaId,
      }).then((item) => {
        setLocationDescOptions(item);
      });
      getFindDropDownList('findDropDownGoodsType', {
        warehouse: locationCode,
      }).then((item) => {
        setGoodsTypeOptions(item);
      });
      setEmptyHawbNo();
    }
  };
  const getDetail = () => {
    if (master.mawbNo && master.mawbNo.length > 0) {
      getGoodsPositionMtnFindDetail({
        hawbNo: master.hawbNo,
        mawbNo: master.mawbNo,
        warehouse: master.warehouse,
      }).then((item) => {
        if (item.data.status === 0) {
          const { statusCode: statusCodeTemp, mawbNoDTOs: rowMawbNoDTOsTemp } =
            (item.data.data as {
              statusCode: string;
              mawbNoDTOs: unknown | unknown[];
            }) || {};

          const goodsPositionMtnList = rowMawbNoDTOsTemp as IresultHawbNo[];
          if (goodsPositionMtnList.length > 0) {
            const goodsPositionMtnDetail = goodsPositionMtnList[0];
            setDetail(goodsPositionMtnDetail, statusCodeTemp);
          } else {
            setEmptyDetail();
          }
        } else {
          setEmptyDetail();
        }
      });
    } else {
      setEmptyDetail();
    }
  };
  useEffect(() => {
    getDetail();
  }, [master.mawbNo]);

  useEffect(() => {
    getFindDropDownList('findDropDownStorageLocation', {
      warehouse: locationCode,
      storageAreaId: master.storageAreaId,
    }).then((item) => {
      setLocationDescOptions(item);
    });
  }, [master.storageAreaId]);

  useEffect(() => {
    iniList();
  }, [master.warehouse]);

  useEffect(() => {
    iniList();
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.type6, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({
      ...prev,
      warehouse: masterDefaultValue.warehouse,
    }));
  }, [userType]);

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setFormError(false);
    setRandomValue(Math.random());
    setGoodsImageFile('');
    setHwbImageFile('');
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const goodsSizeRegex = /^\d{1,3}$/;
    const goodsWeightPattern = /^\d{1,10}(\.\d{0,2})?$/;
    if (master.length !== '' && !goodsSizeRegex.test(master.length)) {
      enqueueSnackbar(`長度超過三位數!`);
      dispatch(setLoadingRedux(false));
    } else if (master.width !== '' && !goodsSizeRegex.test(master.width)) {
      enqueueSnackbar(`寬度超過三位數!`);
      dispatch(setLoadingRedux(false));
    } else if (master.height !== '' && !goodsSizeRegex.test(master.height)) {
      enqueueSnackbar(`高度超過三位數!`);
      dispatch(setLoadingRedux(false));
    } else if (
      master.weight !== '' &&
      !goodsWeightPattern.test(master.weight)
    ) {
      enqueueSnackbar(`重量超過十位數，小數兩位數!`);
      dispatch(setLoadingRedux(false));
    } else {
      const result = await confirm(apiName, {
        warehouse: master.warehouse,
        storageAreaId: master.storageAreaId,
        storageAreaDesc: master.storageAreaDesc,
        locationDesc: master.locationDesc,
        goodsType: master.goodsType,
        hawbNo: master.hawbNo,
        mawbNo: master.mawbNo,
        hwbImageFile: master.hwbImageFile,
        goodsImageFile: master.goodsImageFile,
        hwbImageFileName: master.hwbImageFileName,
        goodsImageFileName: master.goodsImageFileName,
        declPiece: master.declPiece,
        storagePiece: master.storagePiece,
        length: master.length,
        width: master.width,
        height: master.height,
        weight: master.weight,
        processCustoms: master.processCustoms,
        goodsDesc: master.goodsDesc,
        remark: master.remark,
        expressid: master.expressid,
        gciDate: master.gciDate,
        statusCode: master.statusCode,
      });

      dispatch(setLoadingRedux(false));
      if (!snackBarRsp(enqueueSnackbar, result)) {
        return;
      }

      setMaster((prev) => ({
        ...prev,

        hawbNo: '',
        mawbNo: '',
        hwbImageFile: '',
        goodsImageFile: '',
        hwbImageFileName: '',
        goodsImageFileName: '',
        declPiece: '',
        storagePiece: '',
        processCustoms: '',
        remark: '',
        goodsDesc: '',
        expressid: '',
        gciDate: '',
        statusCode: '',
      }));
    }

    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.mawbNo === '' || master.hawbNo === '') {
      enqueueSnackbar('【分號、主號】必填。', {
        variant: 'warning',
      });
      return;
    }
    switch (submitKey) {
      case 'confirm':
        handleConfirm();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
  };

  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案
    const name = (e.target as HTMLInputElement)?.name;

    const reader = new FileReader();
    let fileBase64 = '';
    if (file) {
      reader.readAsArrayBuffer(file);
      reader.onloadend = (evt) => {
        if (evt?.target?.readyState === FileReader.DONE) {
          const arrayBuffer = evt.target.result;
          const array = new Uint8Array(arrayBuffer as ArrayBuffer);
          for (let i = 0; i < array.length; i += 1) {
            fileBase64 += String.fromCharCode(array[i]);
          }

          switch (name) {
            case 'goodsImageFile':
              setMaster({
                ...master,
                goodsImageFile: btoa(fileBase64),
                goodsImageFileName: file.name,
              });
              setGoodsImageFile(btoa(fileBase64));
              break;
            case 'hwbImageFile':
              setMaster({
                ...master,
                hwbImageFile: btoa(fileBase64),
                hwbImageFileName: file.name,
              });
              setHwbImageFile(btoa(fileBase64));
              break;
            default:
              break;
          }
        }
      };
    }
    e.target.value = '';
  };

  function hawbNoOnBlur(
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setEmptyDetail();
    const value = e.target?.value;
    if (value && value.length > 0) {
      const list2: Ioption[] = [];
      getFindDropDownOneList('common', 'findDropDownMawbNo', enqueueSnackbar, {
        hawbNo: value,
        warehouse: master.warehouse,
      }).then((item) => {
        setMawbNoOptions(item);
        if (item && item.length > 0) {
          setMaster((prev) => ({
            ...prev,
            mawbNo: item[0],
          }));
        } else {
          setMaster((prev) => ({
            ...prev,
            mawbNo: '',
          }));
        }
      });
    }
  }
  // const hawbNoOnBlur = async (
  //   e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   if (e && e.preventDefault) {
  //     e.preventDefault();
  //   }
  //   const value = e.target.value;

  //   if (value) {
  //     const list2: Ioption[] = [];
  //     getFindDropDownOneList('test', 'test', 'test').then((item) => {
  //       setMawbNoOptions(item);
  //     });
  //   }
  // };

  const emailRegex = new RegExp('/S+@S+.S+/');

  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 貨物儲位設定維護
          </div>
        </div>
        <div className="input-area">
          {userType && isType(userTypeList.admin, userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*快遞倉站：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*分號：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                required
                maxLength={35}
                value={master.hawbNo}
                name="hawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
                onBlur={(e) => {
                  hawbNoOnBlur(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*主號：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              {/* <Select
                value={master.mawbNo}
                onChange={selectChange(updateData)}
                name="mawbNo"
                options={mawbNoOptions}
                // disabled={options.length === 0}
              /> */}

              <Autocomplete
                inputValue={master.mawbNo}
                onInputChange={(event, newInputValue) => {
                  setMaster((prev) => ({
                    ...prev,
                    mawbNo: newInputValue,
                  }));
                }}
                options={mawbNoOptions}
                renderInput={(params) => <TextField {...params} label="" />}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*儲區：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                required
                value={master.storageAreaId}
                onChange={selectChange(updateData)}
                name="storageAreaId"
                options={storageAreaOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*儲位：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                required
                value={master.locationDesc}
                onChange={selectChange(updateData)}
                name="locationDesc"
                options={locationDescOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              貨物分號標籤照：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                disabled={false}
                maxLength={35}
                value={master.hwbImageFileName}
                name="hwbImageFileName"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <input
                name="hwbImageFile"
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file"
                // multiple
                type="file"
                onChange={selectFile}
                capture="camera"
              />
              <label htmlFor="contained-button-file">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<AttachFileIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: 'blue',
                  }}
                >
                  照相
                </Button>
              </label>
            </Grid>

            <Grid item xs={8} sm={3} md={3} lg={3}>
              <input
                name="hwbImageFile"
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file2"
                // multiple
                type="file"
                onChange={selectFile}
              />
              <label htmlFor="contained-button-file2">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<AttachFileIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: 'blue',
                  }}
                >
                  選擇圖片
                </Button>
              </label>
            </Grid>
          </Grid>

          {master.hwbImageFile && master.hwbImageFile.length > 0 && (
            <div
              key={Math.random()}
              role="button"
              tabIndex={0}
              // onClick={() => handleReset()}
              // onKeyDown={(event) => {
              //   if (event.key === 'Enter') {
              //     handleReset();
              //   }
              // }}
            >
              <img
                key={Math.random()}
                src={`data:image/jpg;base64,${master.hwbImageFile}`}
                style={{
                  width: 'auto',
                  height: 'auto',
                  maxWidth: '200px',
                  maxHeight: '150px',
                }}
                alt=""
              />
            </div>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              貨物整體照：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                disabled={false}
                maxLength={35}
                value={master.goodsImageFileName}
                name="goodsImageFileName"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <input
                name="goodsImageFile"
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file3"
                // multiple
                type="file"
                onChange={selectFile}
                capture="camera"
              />
              <label htmlFor="contained-button-file3">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<AttachFileIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: 'blue',
                  }}
                >
                  照相
                </Button>
              </label>
            </Grid>

            <Grid item xs={8} sm={3} md={3} lg={3}>
              <input
                name="goodsImageFile"
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file4"
                // multiple
                type="file"
                onChange={selectFile}
              />
              <label htmlFor="contained-button-file4">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<AttachFileIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: 'blue',
                  }}
                >
                  選擇圖片
                </Button>
              </label>
            </Grid>
          </Grid>

          {master.goodsImageFile && master.goodsImageFile.length > 0 && (
            <div
              key={Math.random()}
              role="button"
              tabIndex={0}
              // onClick={() => handleReset()}
              // onKeyDown={(event) => {
              //   if (event.key === 'Enter') {
              //     handleReset();
              //   }
              // }}
            >
              <img
                key={Math.random()}
                src={`data:image/jpg;base64,${master.goodsImageFile}`}
                style={{
                  width: 'auto',
                  height: 'auto',
                  maxWidth: '200px',
                  maxHeight: '150px',
                }}
                alt=""
              />
            </div>
          )}

          <Grid container>
            <VcEGrid item xs={2} sm={2} className="input-text">
              <FormTitle>申報件數：</FormTitle>
            </VcEGrid>
            <Grid item xs={3} sm={2}>
              <Input
                disabled
                maxLength={35}
                value={master.declPiece}
                name="declPiece"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
            <VcGrid item xs={1} sm={1}>
              件
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={2} sm={2} className="input-text">
              <FormTitle>*移入件數：</FormTitle>
            </VcEGrid>
            <Grid item xs={3} sm={2}>
              <Input
                required
                maxLength={35}
                value={master.storagePiece}
                name="storagePiece"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
            <VcGrid item xs={1} sm={1}>
              件
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={2} sm={2} className="input-text">
              <FormTitle>長：</FormTitle>
            </VcEGrid>
            <Grid item xs={3} sm={2}>
              <Input
                maxLength={3}
                value={master.length}
                name="length"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
            <VcGrid item xs={1} sm={1}>
              CM
            </VcGrid>

            <VcEGrid item xs={2} sm={2} className="input-text">
              <FormTitle>寬：</FormTitle>
            </VcEGrid>
            <Grid item xs={3} sm={2}>
              <Input
                maxLength={3}
                value={master.width}
                name="width"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
            <VcGrid item xs={1} sm={1}>
              CM
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={2} sm={2} className="input-text">
              <FormTitle>高：</FormTitle>
            </VcEGrid>
            <Grid item xs={3} sm={2}>
              <Input
                maxLength={3}
                value={master.height}
                name="height"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
            <VcGrid item xs={1} sm={1}>
              CM
            </VcGrid>

            <VcEGrid item xs={2} sm={2} className="input-text">
              <FormTitle>重量：</FormTitle>
            </VcEGrid>
            <Grid item xs={3} sm={2}>
              <Input
                maxLength={13}
                value={master.weight}
                name="weight"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
            <VcGrid item xs={1} sm={1}>
              KG
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>貨物分類：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                value={master.goodsType}
                onChange={selectChange(updateData)}
                name="goodsType"
                options={goodsTypeOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>承辦關員：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={10}
                value={master.processCustoms}
                name="processCustoms"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>貨名：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={6}>
              <Input
                maxLength={512}
                value={master.goodsDesc}
                name="goodsDesc"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>備註：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={6}>
              <Input
                maxLength={100}
                value={master.remark}
                name="remark"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              確定
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default GoodsPositionMtn;
